import { HttpLink } from '@apollo/client';

import { getCheckoutGraphqlIdentityQueryRaw } from '@utils/checkout_graphql_identity';

import fetch from 'unfetch';

/** Append GET query segments so Landing API aligns visitor/Draft identity with checkout URL params. */
function mergeGraphqlUriQuery(rawUri: string, operationName?: string): string {
  const trimmed = rawUri.trim();

  const hashIdx = trimmed.indexOf('#');
  const beforeHash = hashIdx >= 0 ? trimmed.slice(0, hashIdx) : trimmed;
  const fragment = hashIdx >= 0 ? trimmed.slice(hashIdx) : '';

  const queryIdx = beforeHash.indexOf('?');
  const pathOnly = queryIdx >= 0 ? beforeHash.slice(0, queryIdx) : beforeHash;
  const existingQuery = queryIdx >= 0 ? beforeHash.slice(queryIdx + 1) : '';

  const qp = new URLSearchParams(existingQuery);

  if (process.env.NODE_ENV === 'development' && operationName) {
    qp.set('op', operationName);
  }

  const identity = getCheckoutGraphqlIdentityQueryRaw();
  if (identity) {
    new URLSearchParams(identity).forEach((value, key) => {
      qp.set(key, value);
    });
  }

  const q = qp.toString();
  const withQuery = q ? `${pathOnly}?${q}` : pathOnly;
  return `${withQuery}${fragment}`;
}

export const buildHttpLink = (uri: string) =>
  new HttpLink({
    uri: ({ operationName }) => mergeGraphqlUriQuery(uri, operationName ?? ''),
    fetch,
    credentials: 'include',
  });
